import { render, staticRenderFns } from "./PaymentFeatureSection.vue?vue&type=template&id=68834062&"
import script from "./PaymentFeatureSection.vue?vue&type=script&lang=js&"
export * from "./PaymentFeatureSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports